import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { Observable } from "rxjs/Observable";
import { EMPTY } from "rxjs";
@Injectable({
    providedIn: "root",
})
export class BrandsServiceService {
    url: string;
    constructor(private http: HttpClient) {
        this.url = environment.api + "/api/customer/";
    }

    getBrands(page:any) {
        return this.http.get(`${this.url}brands?page=${page}`).catch((error: any) => {
            return EMPTY;
        });
    }
    getHomeBrands() {
        return this.http.get(`${this.url}home/brands`).catch((error: any) => {
            return EMPTY;
        });
    }

    getBrand(id: any) {
        return this.http.get(`${this.url}brands/${id}`).catch((error: any) => {
            return EMPTY;
        });
    }
}
